import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const ListCard = ({data, index}:{data: WebsitePageSection, index?: number}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-4 bg-[#F2F2F2] p-4 lg:p-6">
      {index ?  <Paragraph className="flex items-center justify-center text-white bg-wine-100 p-2 !text-xl w-12 h-12">{index}</Paragraph> : null}
        <div className="flex items-center gap-4">
          <Heading level={4} >{data.title ?? "Default Title"}</Heading>
        </div>
        <Paragraph dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Default Description")} />
      </div>
    </EditableSection>
  )
}

export default ListCard